import { useState } from 'react';
import { faqs } from '@/mocks/mangaData';

export default function FAQ() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-24">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <div className="flex flex-col items-center text-center">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-4 py-1.5 text-xs font-semibold text-primary-700">
            <i className="ri-question-answer-line text-sm" />
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            你可能想知道的
          </h2>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            关于追更提醒、缓存下载与订阅，这里都有答案。
          </p>
        </div>

        <div className="mt-10 flex flex-col gap-3">
          {faqs.map((item) => {
            const isOpen = open === item.id;
            return (
              <div
                key={item.id}
                className={`overflow-hidden rounded-2xl bg-background-50 ring-1 transition-colors ${
                  isOpen ? 'ring-primary-300' : 'ring-background-200'
                }`}
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : item.id)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-semibold text-foreground-950 md:text-base">
                    {item.question}
                  </span>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-colors ${
                      isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-600'
                    }`}
                  >
                    <i
                      className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-base transition-transform`}
                    />
                  </span>
                </button>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                    {item.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}